import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Environment } from '../classes/environment';

import { FileInfo } from 'src/app/classes/fileInfo';


@Injectable( { providedIn: 'root' } )
export class OldFileService {

	constructor(
        private _http: HttpClient,
		@Inject('environment') private environment: Environment,
		private matSnackBar: MatSnackBar,
	) {}

	getAll(): Observable<FileInfo[]> {

		return this._http.get<{ downloads: FileInfo[]}>( this.environment.backendUrl + 'download/all' ).pipe( 
			map( wrapper => {
				// console.log( 'SECTIONS', sections )
				let files: FileInfo[] = [];
				if( wrapper && wrapper.downloads ) files = wrapper.downloads;
				return files;
			}),
			catchError(err => {
				console.log( 'An error occurred while fetching the list of files', err );
				this.matSnackBar.open( 'Beim Abrufen der Dateiliste ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of([]);
			})
		);

	}

	getGeneralFiles(): Observable<FileInfo[]> {

		return this._http.get<FileInfo[]>( this.environment.backendUrl + 'download/allgemein' ).pipe( 
			map( files => {
				if( !files || !files.length ) files = [];
				return files;
			}),
			catchError(err => {
				console.log( 'An error occurred while fetching the list of files', err );
				this.matSnackBar.open( 'Beim Abrufen der Dateien-Liste ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of([]);
			})
		);

	}

	getMemberFiles(): Observable<FileInfo[]> {

		return this._http.get<FileInfo[]>( this.environment.backendUrl + 'download/mitglied' ).pipe( 
			map( files => {
				if( !files || !files.length ) files = [];
				return files;
			}),
			catchError(err => {
				console.log( 'An error occurred while fetching the list of files', err );
				this.matSnackBar.open( 'Beim Abrufen der Dateien-Liste ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of([]);
			})
		);

	}

	getSectionFiles(): Observable<FileInfo[]> {

		return this._http.get<FileInfo[]>( this.environment.backendUrl + 'download/sparte' ).pipe( 
			map( files => {
				if( !files || !files.length ) files = [];
				return files;
			}),
			catchError(err => {
				console.log( 'An error occurred while fetching the list of files', err );
				this.matSnackBar.open( 'Beim Abrufen der Dateien-Liste ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of([]);
			})
		);

	}

	create( element: FileInfo, file: File ): Observable<boolean> {
		console.log( 'file', file )
		delete (<any>element).category;
		delete (<any>element).file;

		const params = new HttpParams()
			.set( 'allgemein', element.dlAllgemein ? 'true' : 'false' )
			.set( 'bereich', element.dlBereich )
			.set( 'bezeichnung', element.dlBezeichnung )
			.set( 'gueltigAb', element.dlGueltigAb.toString() )
			.set( 'gueltigBis', element.dlGueltigBis.toString() )
			.set( 'mitgliedId', element.mitgliedId )
			.set( 'sparten', JSON.stringify(element.sparten) )


		const formData = new FormData();
		formData.append('file', file, file.name);
		// formData.append( 'download', JSON.stringify(element) )


		return this._http.post<{ verarbeitet: boolean }>( 
			this.environment.backendUrl + 'datei/upload',
			{ file: formData, },
			{ params: params }
		).pipe(
			map( response => {
				if( !response ) {
					this.matSnackBar.open( 'Hochladen fehlgeschlagen', '', { duration: 5000 } );
					return false;
				}
				this.matSnackBar.open( 'Hochladen erfolgreich', '', { duration: 5000 } );
				return true;
			}),
			catchError(err => {
				console.log( 'An error occurred while uploading the file', err );
				this.matSnackBar.open( 'Beim Hochladen der Datei ist ein Fehler aufgetreten', '', { duration: 5000 } );
				return of(false);
			})
		)
	}

	update( element: FileInfo ): Observable<boolean> {

		return of(false);
		// return this._http.put<ReportingYear>( 
		// 	this.environment.backendUrl + 'behrichtsjahr/update',
		// 	element
		// ).pipe(
		// 	map( response => {
		// 		if( !response ) {
		// 			this.matSnackBar.open( 'Änderung fehlgeschlagen', '', { duration: 5000 } );
		// 			return false;
		// 		}
		// 		this.matSnackBar.open( 'Änderung erfolgreich', '', { duration: 5000 } );
		// 		return true;
		// 	}),
		// 	catchError(err => {
		// 		console.log( 'An error occurred while updating a reporting year', err );
		// 		this.matSnackBar.open( 'Beim Aktualisieren einer Berichtsjahre ist ein Fehler aufgetreten', '', { duration: 5000 } );
		// 		return of(false);
		// 	})
		// )
	}


}